import { FINALE, STREAMERS, type ScheduleItem } from '../data/streamers';
import { useScheduleStatuses } from '../hooks/useScheduleStatus';

import styles from './ScheduleTimeline.module.css';
import { StreamerScheduleCard } from './StreamerScheduleCard';

interface ScheduleTimelineProps {
  /** 합방 피날레 카드를 함께 보여줄지 여부. 기본 true. */
  includeFinale?: boolean;
}

/**
 * 어린이날 릴레이 방송 일정 전체 섹션.
 *
 * 3인의 솔로 방송 + (옵션) 합방 피날레를 시간 순으로 나열한다.
 * 매 분마다 현재 시각과 비교해 LIVE / UP NEXT / 종료 / 대기 상태를 갱신한다.
 *
 * 클라이언트는 서버처럼 단일 카운트만 추적하므로, 카드별 "이미 등록됨" 표식은
 * 표시하지 않는다 (서버가 어떤 스트리머의 코드인지 구분하지 않기 때문).
 */
export function ScheduleTimeline({
  includeFinale = true,
}: ScheduleTimelineProps): React.JSX.Element {
  const items: readonly ScheduleItem[] = includeFinale ? [...STREAMERS, FINALE] : STREAMERS;
  const statuses = useScheduleStatuses(items);

  return (
    <section className={styles.section} aria-labelledby="schedule-heading">
      <header className={styles.header}>
        {/* <span className={styles.eyebrow}>2026년 5월 5일 · 어린이날</span> */}
        <h2 id="schedule-heading" className={styles.title}>
          3인의 <span className={styles.titleAccent}>릴레이</span> 방송 일정
        </h2>
        <p className={styles.lead}>
          각 방송에서 랜덤으로 코드가 공개돼요.
        </p>
      </header>

      <ol className={styles.list}>
        {items.map((item, idx) => (
          <li key={item.id} className={styles.listItem}>
            <StreamerScheduleCard
              item={item}
              status={statuses[idx] ?? 'upcoming'}
            />
          </li>
        ))}
      </ol>

      <p className={styles.footnote}>
        ※ 시간은 운영 사정에 따라 변동될 수 있어요.
      </p>
    </section>
  );
}
